export default __webpack_public_path__ + "images/EC.8b3174b.png";